import { useEffect } from 'react'

/** Tab title, most specific part first: `Queue · Hanoi · Phở 24 · Romi` (2026-09-13). */
export function useDocumentTitle(...parts: (string | undefined)[]) {
  const title = parts.filter(Boolean).join(' · ')
  useEffect(() => {
    document.title = title
  }, [title])
}
